import AppStore from '@v4/store/appStore'
import { useMemo } from 'react'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import ThemeSelector from '@v4/utils/selectors/ThemeSelector'
import { STATUS_TYPE } from '@v4/constants/quiz'
import PageData from '@v4/utils/data/PageData'
import { MERGE_TAG } from '@v4/hooks/useEditor/useEditor.const'
import PageMetaData from '@v4/utils/data/PageMetaData'
import useOverallScore from './useOverallScore'

const useShortcuts = extraShortcuts => {
	const pageType = PageBuilderSelector.useType()
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const appShortcuts = AppStore.useStoreState(state => state.shortcuts.data)
	const builderShortcuts = PageBuilderSelector.useShortcuts()
	const theme = ThemeSelector.useTheme()
	const defaultShortcuts = isBuilderMode ? builderShortcuts : appShortcuts

	const { tierName } = useOverallScore({
		group: 'content',
	})

	const status = AppStore.useStoreState(state => state.question.status)
	const percentage = AppStore.useStoreState(state => state.question.percentage || 0)
	const percent = status === STATUS_TYPE.FINISHED ? 100 : percentage

	const questionShortcuts = useMemo(
		() => ({
			progress_percent: `${percent || 0}%`,
		}),
		[percent],
	)

	const getImageTag = url => {
		return url
			? `<img src=${PageMetaData.imageThumbUrlFrom(
					url,
					460,
			  )} alt="" width="230" style="max-width: 230px; max-height: 
         90px; width: auto; height: auto;">`
			: null
	}

	const logoShortcuts = useMemo(
		() => ({
			[MERGE_TAG.SCORECARD_LOGO]: getImageTag(theme.images?.logo?.path),
			[MERGE_TAG.SECONDARY_LOGO]: getImageTag(theme.images?.secondaryLogo?.path),
			[MERGE_TAG.SQUARE_ICON]: getImageTag(theme.images?.icon?.path),
		}),
		[theme.images],
	)

	return useMemo(
		() => ({
			...(defaultShortcuts || {}),
			...(isBuilderMode && tierName ? { overall_score_tier: tierName } : {}),
			...(extraShortcuts || {}),
			...logoShortcuts,
			...(PageData.isTypeQuestions(pageType) ? questionShortcuts : {}),
		}),
		[defaultShortcuts, extraShortcuts, isBuilderMode, logoShortcuts, pageType, questionShortcuts, tierName],
	)
}

export default useShortcuts
